import {
  AppModal,
  IconButton,
  PopupHeader
} from '../';
import {
  SessionResultImage,
  SessionResultContainer,
  SessionResultControls,
  SessionResultDecorator,
  StyledSessionResultPopup
} from './SessionResultPopup.styled';
import { useEffect } from 'react';
import { useAudio } from '../../providers/AudioContext';
import { useEarningsStore } from '../../store/gameEarnings.store';

const SessionResultPopup = ({ data: { status }, onAccept }) => {
  const title = status === 'Won' ? 'You won' : status === 'Lost' ? 'You lost' : 'You idiot';
  const imageUrl = status === 'Won' ? '/assets/youwon.gif' : '/assets/youlost.gif';
  const track = status === 'Won' ? 'victory' : 'defeat';

  const { lastPlayedLevel, maxLevel } = useEarningsStore();
  const finalWin = (lastPlayedLevel === maxLevel) && status === 'Won';

  // Play custom sfx with probability of 20% or on every final win
  const playCustomSfx = finalWin || (Math.random() <= 0.2);

  const sfx = finalWin
    ? `final${Math.floor(Math.random() * 6) + 1}`
    : `${status === 'Won' ? 'win' : 'lose'}${Math.floor(Math.random() * 5) + 1}`;
  const { playMusic } = useAudio();

  useEffect(() => {
    playMusic(track);
  }, []);

  return (
    <AppModal sound={playCustomSfx ? sfx : 'popup'}>
      <StyledSessionResultPopup>
        <SessionResultImage src={imageUrl}/>
        <PopupHeader title={title}/>
        <SessionResultContainer>
          <SessionResultDecorator/>
          <SessionResultControls>
	    <IconButton onClick={() => {
              playMusic('equip');
	      onAccept();
	    }}>
              Accept
            </IconButton>
          </SessionResultControls>
        </SessionResultContainer>
      </StyledSessionResultPopup>
    </AppModal>
  );
};

export default SessionResultPopup;
